import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="sidebar"
export default class extends Controller {
	static targets = ['menuButton', 'homeButton', 'calendar', 'search', 'tags'];

	connect() {
		this.maybeStopScrolling();

		let lastScrollTop = document.documentElement.scrollTop;

		// this initializes the scrollTop with a bit of a "buffer" zone when you first load the page
		lastScrollTop = lastScrollTop + 100;

		const sidebar = this.element;

		// reveals the mobile menu as you scroll
		window.addEventListener('scroll', function () {
			// grab the height of the page at the start of a scroll
			let topOfPage = window.scrollY;

			// when the top of the page is now less than the previous location and it's not equal to 0
			if (topOfPage > lastScrollTop && topOfPage !== 0) {
				sidebar.classList.remove('reveal');
			} else {
				// if we are at the bottom of the page, don't add the reveal class as it can hide important information or actions
				if (window.innerHeight + window.scrollY < document.body.offsetHeight) {
					sidebar.classList.add('reveal');
				}
			}

			// iOS rubber banding can produce weird effects on the page height. Thus, just don't update if we're reading a negative page height.
			if (topOfPage > 0) {
				lastScrollTop = topOfPage;
			}
		});
	}

	maybeStopScrolling() {
		// if the home button is not active, another button was clicked
		// in this case, prevent scrolling
		if (!this.homeButtonTarget.classList.contains('active')) {
			this.homeButtonTarget.classList.remove('active');
			document.body.classList.add('stop-scrolling');
			document.body.addEventListener('touchmove', this.preventDefault);
		} else {
			this.homeButtonTarget.classList.add('active');
			document.body.classList.remove('stop-scrolling');
			document.body.addEventListener('touchmove', this.preventDefault);
		}
	}

	home() {
		window.location = '/';
	}

	toggleContent(event) {
		let clickedButton = event.target;

		// handle if active button is clicked
		if (clickedButton.classList.contains('active')) {
			this.homeButtonTarget.classList.add('active');
			clickedButton.classList.remove('active');
		} else {
			this.homeButtonTarget.classList.remove('active');
			clickedButton.classList.add('active');
		}

		this.menuButtonTargets.forEach((menuButton) => {
			let el = this[menuButton.dataset.element + 'Target'];
			if (clickedButton === menuButton) {
				el.classList.toggle('reveal');
			} else {
				el.classList.remove('reveal');
				menuButton.classList.remove('active');
			}
		});

		this.maybeStopScrolling();
	}

	preventDefault(event) {
		console.log('click');
		event.preventDefault();
	}
}
